export { ReceiptPage } from './receipt-page.component';
